import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  Auth: {
    AuthorityUrl: string;
    ClientId: string;
    Scopes: string;
  };
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('configuration for auth module');

const DEFAULT_AUTH_CONFIG: AuthConfig = {
  Auth: {
    AuthorityUrl: '',
    ClientId: '',
    Scopes: 'openid profile offline_access',
  },
};

export function getAuthConfigWithDefaults(config: AuthConfig): AuthConfig {
  return { ...DEFAULT_AUTH_CONFIG, ...config } as AuthConfig;
}
